import { render, staticRenderFns } from "./LLP_accordion.vue?vue&type=template&id=5e8f6424&"
import script from "./LLP_accordion.vue?vue&type=script&lang=js&"
export * from "./LLP_accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports